// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"112b8b78","453":"e8d6f2f9","455":"a872c772","889":"c5bf2eab","977":"d90ac337"}[chunkId] + ".chunk.js";
};